import React, { useState, useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { BsFillInfoSquareFill } from "react-icons/bs";
import appConfig from "../../config/app.config";
import useApiClient, { apiRoutes } from "../../hooks/apiClient";
import AssinadorAccordion from "./Components/AssinadorAccordion";

const AssinaturaFila = () => {
  const [pageNumber] = useState(1);
  const [grupoDocumento, setGrupoDocumento] = useState([]);

  const { request: requestGrupoDocumento, data: dataGrupoDocumento } = useApiClient();

  useEffect(() => {
    requestGrupoDocumento(apiRoutes.fiscalizacao.ordemservico.consultaGrupoDocumento);
  }, [requestGrupoDocumento]);

  useEffect(() => {
    if (dataGrupoDocumento) {
      setGrupoDocumento(dataGrupoDocumento.result || []);
    }
  }, [dataGrupoDocumento]);

  return (
    <>
      <Row>
        <Col sm="12">
          <h1 className="h3 mb-4 text-gray-800">Assinaturas Pendentes</h1>
        </Col>
      </Row>

      <div className="row">
        <div className="col-lg-12">
          <div className="card shadow mb-4">
            <div className="card-header pt-3 pb-0 flex-row w-100">
              <Form.Group as={Row} className="d-flex flex-row">
                <h6 className="font-weight-bold text-primary flex-grow-1 ml-2 mt-2">
                  {" "}
                  Consulta de Assinaturas Pendentes{" "}
                </h6>

                <div className="card-divider d-none d-sm-block" />
              </Form.Group>
            </div>

            <div className="card-body">
              {grupoDocumento.map((item, index) => (
                <div key={index}>
                  <AssinadorAccordion item={item.grupoDocumento} index={index} PageNumber={pageNumber} />
                </div>
              ))}
              <br />
              <small>
                <a href={`${appConfig.hosts.auth}assets/setrn-guard-win-x64-setup.exe`}>
                  <BsFillInfoSquareFill />
                  &nbsp;Baixar Assinador
                </a>
              </small>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AssinaturaFila;
